import React from "react";
import { Layout } from "antd";

const LayoutFooter: React.FunctionComponent = () => (
    <Layout.Footer
        style={{
            textAlign: "center",
            backgroundColor: "white",
            borderTop: "1px solid rgba(5, 5, 5, 0.06)"
        }}
    >
        <p>Bản quyền © 2024. Mọi quyền được bảo lưu.</p>
    </Layout.Footer>
);

export default LayoutFooter;